import { Component, OnInit, DoCheck } from '@angular/core';


@Component({
  selector: 'bid-dashboard',
  templateUrl: './dashboard-users.component.html',
  styleUrls: ['./dashboard-users.component.scss'],
})
export class DashboardUsersComponent implements OnInit, DoCheck {
  //showHistoricalSearch: boolean;
  constructor() {
    //this.showHistoricalSearch = false;
  }

  ngOnInit() {
    //this.showHistoricalSearchService.setShowHistoricalSearch(false);
  }

  ngDoCheck() {
     
  }
}
